module.exports = __webpack_public_path__ + "static/media/front.5d4b8c26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/front.png
// module id = 200
// module chunks = 0